import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, X } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const DISMISS_KEY = "empco_maintenance_dismissed_at";

const LEVELS = {
  info: "bg-blue-500/10 border-blue-500/30 text-blue-200",
  warning: "bg-amber-500/10 border-amber-500/30 text-amber-200",
  critical: "bg-rose-500/10 border-rose-500/30 text-rose-200",
};

export default function MaintenanceBanner() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let stop = false;
    const load = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/system/maintenance`, { timeout: 4000 });
        if (!stop) setBanner(data.enabled ? data : null);
      } catch (e) {
        console.debug("Maintenance fetch failed (silent):", e?.message);
      }
    };
    load();
    const iv = setInterval(load, 60_000); // refresh 1x/min
    return () => { stop = true; clearInterval(iv); };
  }, []);

  useEffect(() => {
    if (!banner) return;
    const prev = localStorage.getItem(DISMISS_KEY);
    // reset la dismiss si le message a changé (nouveau timestamp maj)
    const key = `${banner.level}::${banner.message}`;
    if (prev === key) setDismissed(true);
    else setDismissed(false);
    if (banner) window.__EMPCO_BANNER_KEY__ = key;
  }, [banner]);

  if (!banner || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    if (banner.dismissible) localStorage.setItem(DISMISS_KEY, `${banner.level}::${banner.message}`);
  };

  return (
    <div className={`w-full border-b ${LEVELS[banner.level] || LEVELS.info}`} data-testid="maintenance-banner">
      <div className="max-w-[1400px] mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <p className="flex-1">
          <span className="font-semibold uppercase text-[10px] tracking-widest mr-2">{banner.level}</span>
          {banner.message}
          {banner.scheduled_at && <span className="ml-2 opacity-75 text-xs">— {new Date(banner.scheduled_at).toLocaleString("fr-FR")}</span>}
        </p>
        {banner.dismissible && (
          <button onClick={dismiss} data-testid="maintenance-banner-dismiss" className="opacity-60 hover:opacity-100">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
